import { useState } from "react"
import Header from "../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Grid, Button } from "@mui/material"

import BackIcon from "../../components/BackIcon"

import { NavLink, useNavigate } from "react-router-dom"

import BuscarIcon from "../../assets/iconos/Buscar.ico"
import CrearIcon from "../../assets/iconos/Crear.ico"
import EditIcon from "@mui/icons-material/Edit"
import AddIcon from "@mui/icons-material/Add"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward"

import CustomConditionalActionsTableServer from "../../components/CustomConditionalActionsTableServerSide"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"
import EliminarIcon from "../../assets/iconos/Eliminar.ico"
import normalFormatDate from "../utils/date/DDMMYYYFormatDate"
import {
  handleExportDataPdfLGScreen,
  handleExportDataPdfSMScreen,
  handleAllExportDataCSV,
} from "../utils/reactTableActions/exportToolbarActions"
import normalFormatHour from "../utils/date/HHMMSSFormatHour"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const StyledSmallIcon = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  color: ({ theme }) => theme.palette.text.primary,

  "& img": {
    width: "25px",
    height: "25px",
  },
})

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const EjecucionLabores = () => {
  const navigate = useNavigate()
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Ejecucion de Labores</b>
        </div>

        <Box className={StyledRoot}>
          <CustomConditionalActionsTableServer
            // key={`UsuariosCreacion-${refreshCustomMultiRowSelectionRefKey}-${forceDataRefresh}`}
            // key={`UsuariosCreacion`}
            endpoint="/EjecucionLabores/getAllEventosEjecutados"
            errorMsgFilterSearch="Error en cargar datos"
            queryKeyModal="getAllEventosEjecutados"
            perPage={10}
            rowActionsWidthTable={150}
            rowActions={(row) => {
              // const record = row.original
              const actions = [
                {
                  label: "Ver",
                  key: "VerAction",
                  icon: <RemoveRedEyeIcon sx={{ color: "#14AFF7" }} />,
                  onClick: (row) => {
                    navigate(`buscar`, { state: row.original })
                  },
                },
              ]

              return actions
            }}
            topToolbarCustomActions={({ table, device }) => {
              const toolbarActions = [
                {
                  label: "Crear ejecucción",
                  key: "creaEejecucion",
                  icon: (
                    <StyledSmallIcon to="crear">
                      <img src={CrearIcon} alt="Crear" />
                    </StyledSmallIcon>
                  ),
                  onClick: () => {
                    navigate("crear")
                  },
                },
                // {
                //   label: "Exportar PDF",
                //   key: "exportarPDF",
                //   icon: <PictureAsPdfIcon sx={{ color: "#14AFF7" }} />,
                //   onClick: ({ columns, data }) => {
                //     if (device === "sm") {
                //       return handleExportDataPdfSMScreen(
                //         columns,
                //         data,
                //         "Reporte de usuarios",
                //         `Reporte de Usuarios ${new Date().toLocaleString()}`,
                //       )
                //     }
                //     handleExportDataPdfLGScreen(
                //       columns,
                //       table.getCoreRowModel().rows,
                //       "Reporte de usuarios",
                //       `Reporte de Usuarios ${new Date().toLocaleString()}`,
                //     )
                //   },
                // },
                // {
                //   label: "Exportar CSV",
                //   key: "exportarCSV",
                //   icon: <ArrowDownwardIcon sx={{ color: "#14AFF7" }} />,
                //   onClick: ({ data }) => {
                //     handleAllExportDataCSV(data, `Reporte de Usuarios ${new Date().toLocaleString()}`)
                //   },
                // },
              ]
              return toolbarActions
            }}
            columnsTable={[
              {
                accessorKey: "ejecnumero",
                header: "Número Ejecución",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "ciacodigo",
                header: "Código Compañía",
                size: 120,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "emcodemp",
                header: "Código Empleado",
                size: 120,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "empleadoNombre",
                header: "Nombre Empleado",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },

              {
                accessorKey: "localidadNombre",
                header: "Localidad",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },

              {
                accessorKey: "horarioDesc",
                header: "Descripción Horario",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              // {
              //   accessorKey: "horini",
              //   header: "Hora Inicio",
              //   size: 100,
              //   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              // },
              // {
              //   accessorKey: "horfin",
              //   header: "Hora Fin",
              //   size: 100,
              //   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              // },
              {
                accessorKey: "plandescri",
                header: "Descripción Plan",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "ejecfecha",
                header: "Fecha de entrada",
                size: 300,
                Cell: ({ cell }) => <span>{normalFormatDate(cell.getValue())}</span>,
              },
              {
                accessorKey: "ejechora",
                header: "Hora de entrada",
                size: 300,
                Cell: ({ cell }) => <span>{normalFormatHour(cell.getValue())}</span>,
              },

              // {
              //   accessorKey: "hordiaini",
              //   header: "Día Inicio",
              //   size: 100,
              //   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              // },
              // {
              //   accessorKey: "hordiafin",
              //   header: "Día Fin",
              //   size: 100,
              //   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              // },

              // {
              //   accessorKey: "ejecstatus",
              //   header: "Estado Ejecución",
              //   size: 120,
              //   Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              // },
              // {
              //   accessorKey: "ejecimagen",
              //   header: "Imagen",
              //   size: 100,
              //   Cell: ({ cell }) =>
              //     cell.getValue() ? (
              //       <img
              //         src={`data:image/jpeg;base64,${cell.getValue()}`}
              //         alt="Evidencia"
              //         style={{ width: "50px", height: "50px", objectFit: "cover" }}
              //       />
              //     ) : (
              //       <span>Sin imagen</span>
              //     ),
              // },
              // {
              //   accessorKey: "ubicacion",
              //   header: "Ubicación",
              //   size: 150,
              //   Cell: ({ cell }) =>
              //     cell.getValue() ? (
              //       <span>
              //         Lat: {cell.getValue().latitud}, Long: {cell.getValue().longitud}
              //       </span>
              //     ) : (
              //       <span>Sin ubicación</span>
              //     ),
              // },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default EjecucionLabores
